/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-05 15:54:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchLegalPage } from 'src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/slice';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import css from './css.module.less';

const CloneBtn = (props) => {
  const params: any = useParams();
  const { legalPageUuid } = params;
  const _d = useDispatch();
  const handleOnClick = () => {
    _d(
      fetchLegalPage({
        //1===true 0===false
        uuid: legalPageUuid,
        params: {
          [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
        },
        isClone: true,
      }),
    );
  };
  return (
    <div className={css.container}>
      <Button
        onClick={handleOnClick}
        btnClassName={css.btn}
        className={css.innerContainer}
        disabled={props?.disabled}
      />
    </div>
  );
};
export default CloneBtn;
